<template>
  <header
    id="topnav"
    class="navbar navbar-default navbar-fixed-top"
    role="banner"
  >
    <!-- <div id="page-progress-loader" class="show"></div> -->

    <div class="logo-area">
      <a class="navbar-brand navbar-brand-primary" >
        <img
          class="show-on-collapse img-logo-white"
          alt="Paper"
          src="/assets/img/logo-icon-white.png"
        />
        <img
          class="show-on-collapse img-logo-dark"
          alt="Paper"
          src="/assets/img/logo-icon-dark.png"
        />
        <img class="img-white" alt="Paper" src="/assets/img/admin.png" />
        <img class="img-dark" alt="Paper" src="/assets/img/logo-dark.png" />
      </a>
      <span
        id="trigger-sidebar"
        class="toolbar-trigger toolbar-icon-bg stay-on-search"
      >
        <a data-toggle="tooltips" data-placement="right" title="Toggle Sidebar">
          <span class="icon-bg"> <i class="material-icons">menu</i> </span>
        </a>
      </span>
    </div>
    <!-- logo-area -->

    <ul class="nav navbar-nav toolbar pull-right toll-noti">
      <li
        class="toolbar-icon-bg appear-on-search ov-h"
        id="trigger-search-close"
      >
        <a class="toggle-fullscreen"
          ><span class="icon-bg"> <i class="material-icons">close</i> </span></a
        >
      </li>
      <li class="toolbar-icon-bg hidden-xs" id="trigger-fullscreen">
        <a href="#" class="toggle-fullscreen"
          ><span class="icon-bg">
            <i class="material-icons">fullscreen</i>
          </span></a
        >
      </li>
     
     
      <li class="toolbar-icon-bg" id="trigger-infobar">
        <a data-toggle="tooltips" data-placement="right" title="Toggle Sidebar">
          <span class="icon-bg"> <i class="material-icons">more_vert</i> </span>
        </a>
      </li>
    </ul>
  </header>
</template>
<script>
export default {
  name: 'head-layout',
};
</script>
<style scoped>
.toll-noti{
    display: inline-block;
}
</style>